import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import reloadToken from '../helper/reloadtoken';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.min.css';
import { apiConfig } from '../helper/apiConfig';
import HeaderMenu from '../template/HeaderMenu';

const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const host = process.env.REACT_APP_API_URL_ONLINE;
const hostupload = process.env.REACT_APP_API_HOST_UPLOAD;
const API_AssetList = mainhost + "AssetForDropdown"

const Asset_setting = () => {
  const token = localStorage.getItem('token');
  const [TokenNew, setToken] = useState(null);
  const config = apiConfig(token);
  const hotRef = useRef(null);
  const [accessCode, setAccessCode] = useState('');
  const [colHeaders, setColHeaders] = useState([]);
  const widthLayout = window.innerWidth - 10;
  const heightLayout = window.innerHeight - 10;
  const [listGroup, setListGroup] = useState([]);
  const [listGroupAll, setListGroupAll] = useState([]);
  const [listAsset, setListAsset] = useState([]);
  const [listAssetColumn, setListAssetColumn] = useState([]);
  const [listPercentage, setListPercentage] = useState([]);
  const [listPercentageAsset,setListPercentageAsset] = useState([]);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [asset_group_name, set_asset_group_name] = useState('');
  const today = new Date().toISOString().slice(0, 10);
  const [asset_effective_date, set_asset_effective_date] = useState(today);
  const column_size = 6;
  const deleteAsset = async (id) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `${host}api/asset/delete/${id}`;
    try {
      const response = await axios.delete(url, config);
      if (response.data.status === 200) {
        alert('Delete Success');
        window.location.reload();
      } else {
        alert('Delete Failed');
      }
    } catch (error) {
      alert('Delete Failed');
    }
  };

  const initializeLuckySheet = async () => {
    const response = await axios.post(`${API_AssetList}`, null, config);
    setListAsset(response.data);
    const listAsset = response.data;
    const rows = [];
    for (let i = 1; i < listAsset.length; i += column_size) {
      rows.push(listAsset.slice(i, i + column_size));
    }
    setListAssetColumn(rows);
  }
  let count = 0;
  const handleChange = (value,label) => (e) => {
    const newValue = e.target.value;
    const updatedListPercentageAsset = { ...listPercentageAsset }; // Create a copy
    updatedListPercentageAsset[label] = newValue; // Update the value using the label
    // 3. (Optional) Trigger a state update (if using state)
    if (useState) { // Check if useState is available (functional components)
      setListPercentageAsset(updatedListPercentageAsset);
    } 
    let found = false;
    for (let i = 0; i < listPercentage.length; i++) {
      if (listPercentage[i].label === value) {
        listPercentage[i].value = newValue;
        found = true;
      } 
    }
    if (!found) {
      listPercentage.push({label: value, value: newValue});
    }
    // console.log(listPercentage);

    
    // listPercentageAsset[label] = newValue;
    console.log(listPercentageAsset);
    // console.log(parseFloat(newValue));
    // calculate total percentage
  };
  const calculateTotalPercentage = () => {
    let total = 0.0;
    for (let i = 0; i < listPercentage.length; i++) {
      const val = listPercentage[i].value;
      total += parseFloat(val);
    }
    setTotalPercentage(total);
  };

  const loadAsset = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `${mainhost}get_asset_list`;
    try {
      const response = await axios.post(url,[], config);
      const array_data = response.data;
      let list_group_name = [];
      let list_asset_group =[];
      setListGroup([]);
      setListGroupAll([]);
      array_data.forEach(element => {
          let asset_list = element.toko;
          let percentage = element.percentage;
          let groupname = element.asset;
          let effective_date = element.effective_date;
          setListGroupAll((prev) => [...prev, {groupname: groupname, assetname: asset_list, persentase: percentage, effective_date: element.effective_date}]);
          if (typeof list_asset_group[element.asset+"-"+effective_date] === 'undefined') {
            list_asset_group[element.asset+"-"+effective_date]=[];
          }
          list_asset_group[element.asset+"-"+effective_date].push({"toko" : element.toko, "persen" :element.percentage});
      });
      array_data.forEach(element => {
        if (!list_group_name.includes(element.asset)) {
          let percentage = element.percentage;
          let groupname = element.asset;
          let effective_date = element.effective_date;
          let asset_list = list_asset_group[element.asset+"-"+effective_date];
          if (!list_group_name.includes(groupname+"-"+effective_date)) {
            setListGroup((prev) => [...prev, {groupname: groupname, assetname: asset_list, persentase: percentage, effective_date: element.effective_date}]);
          }
          list_group_name.push(groupname+"-"+effective_date);
        }
      });
    } catch (error) {
    }

    // setListPercentage([{label: '8', value: 20}]);
  };
  const EditAsset = async (group_name, asset_name, effective_date) => {
    console.log(group_name, asset_name, effective_date);
    set_asset_group_name(group_name);
    set_asset_effective_date(effective_date);
    let list_percentages = [];
    let l_p_asset = [];
    listGroupAll.forEach(element =>{
      if(element.groupname == group_name && element.effective_date == effective_date )
      {
        const id_asset = listAsset.find((x) => x.label === element.assetname).value;
        list_percentages.push({label:id_asset,value:element.persentase});
        l_p_asset[element.assetname] = element.persentase;
      }
    });
    console.log(list_percentages);
    console.log(l_p_asset);
    setListPercentageAsset(l_p_asset);
    setListPercentage(list_percentages);
  };
  const savePercentage = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // check all percentage must be 100
    // let total = 0; let count_100 = 0
    // for (let i = 0; i < listPercentage.length; i++) {
    //   if(listPercentage[i].value != "" && listPercentage[i].value > 0) {
    //   total += parseInt(listPercentage[i].value);
    //   count_100 += 1;
    //   }
    // }
    // if (total !== 100 && total/count_100 !== 100) {
    //   alert('Total Percentage must be 100');
    //   return;
    // }
    const url = `${mainhost}save_asset_list`;
    let asset_list = []; let asset_percentage = []; let asset_list_name = [];
    for (let i = 0; i < listPercentage.length; i++) {
      asset_list.push(listPercentage[i].label);
      asset_percentage.push(listPercentage[i].value);
    }
    for (let i = 0; i < asset_list.length; i++) {
      asset_list_name.push(listAsset.find((x) => x.value === asset_list[i]).label);
    }
    try {
      let formData = new FormData();
      formData.append('asset_list', asset_list_name);
      formData.append('percentage', asset_percentage);  
      formData.append('group_name', document.getElementById('groupname').value);
      formData.append('effective_date', document.getElementById('effectivedate').value);
      const response = await axios.post(url, formData, config);
      // console.log(response);
      // if (response.data.status === 200) {
      //   alert('Save Success');
        window.location.reload();
      // } else {
      //   alert('Save Failed');
      // }
    } catch (error) {
      alert('Save Failed');
    }
  };

  useEffect( async () => {
    const newToken = await reloadToken();
    setToken(newToken);
    initializeLuckySheet();
    loadAsset();
  }, []);
  return (
    <div>
      <HeaderMenu title="Asset Group Setting"/>
      
      <div style={{ textAlign: 'center', overflow:'auto', height:'90vh', width:'100%'}}>
      <table>
        <tbody>
        <tr>
          <th style={{ verticalAlign:"top", padding:"10px"}}>
            <table className='table table-bordered'>
              <thead>
                <tr>
                  <th>Nama Group</th>
                  <th>Nama Asset</th>
                  <th>Effective Date</th>
                  {/* <th>Pesentase</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
              {listGroup.map((item, index) => (
                  <tr key={index}>
                    <td>{item.groupname}</td>
                    <td>
                      <table style={{width:"100%"}}>
                        <tbody>
                          {item.assetname.map((items,indexs)=>(
                            <tr key={index+"-"+indexs}>
                            <td style={{ border:"none", textAlign:"right"}}>{items.toko}</td>
                            <td style={{ border:"none"}}>:</td>
                            <td style={{ border:"none", textAlign:"right"}}>{items.persen}%</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                    <td>{item.effective_date}</td>
                    {/* <td>{item.persentase}</td> */}
                    <td><button onClick={() => EditAsset(item.groupname,item.assetname,item.effective_date)}>Edit</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </th>
          <th style={{ verticalAlign:"top", padding:"10px"}}>
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign:'right'}}>Asset Group Name</th>
                  <th colSpan={column_size-1}>
                    <input type="text" name="groupname" value={asset_group_name} id="groupname" onChange={(e) => set_asset_group_name(e.value)}/>
                  </th>
                </tr>
                <tr>
                  <th style={{ borderBottom:'1px dashed #000000',textAlign:'right'}}>Effective Date</th>
                  <th colSpan={column_size-1} style={{ borderBottom:'1px dashed #000000'}}>
                    <input type="date" name="effectivedate" id="effectivedate" value={asset_effective_date} onChange={(e) => set_asset_effective_date(e.value)} />
                  </th>
                </tr>
              </thead>
              <tbody>
              {/* {listAsset.map((item, index) =>(
                item.value === "" ? null :
                <tr key={index}>
                  <td>{item.label}</td>
                  <td>
                    <input type="number" style={{ textAlign:"right"}} name="precentage" id="precentage" onChange={handleChange(item.value)} />
                  </td>
                </tr>
              ))} */}
              {listAssetColumn.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((item, index) => 
                    item.value === "" ? null : (
                      <td key={index}>
                        {item.label}
                        <br />
                        <input 
                          type="text" 
                          style={{ textAlign: "right" }} 
                          name="percentage" 
                          id="percentage" 
                          defaultValue={listPercentageAsset[item.label]}
                          // onChange={handleChange(item.value,item.label)} 
                          onBlur={calculateTotalPercentage}
                        />
                      </td>
                    )
                  )}
                </tr>
              ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={column_size}>
                    <button onClick={savePercentage} className='btn btn-default btn-width-auto'>Save</button>
                    <label>{totalPercentage}%</label>
                  </th>
                </tr>
              </tfoot>
            </table>
          </th>
        </tr>
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Asset_setting;
